<!-- Container-fluid starts-->
<div class="container-fluid" *ngIf="visible">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Channel List</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                    </div>
                    <div class="custom-datatable">
                        <form class="row m-0">

                            <div class="mb-sm-4 col-3">
                                <label>Channel Name</label>
                                <input type='text' class="filter-ngx form-control" placeholder='Channel Name'
                                       [(ngModel)]="filterParams.name" (input)="applySearch()"
                                       autocomplete="off"/>
                            </div>

                            <div class="mb-sm-4 col-3">
                                <label>Channel id</label>
                                <input type='text' class="filter-ngx form-control" placeholder='Channel id'
                                       [(ngModel)]="filterParams.channel_id" (input)="applySearch()"
                                       autocomplete="off"/>
                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>Country Name</label>
                                <select class="form-select form-control" placeholder='Country'
                                        [(ngModel)]="filterParams.country_id" (change)="onSelect($event)">
                                    <option value="" [disabled]="true">Select Country</option>
                                    <option *ngFor="let item of countries"
                                            [ngValue]="item.country_id">{{item.country_name}}</option>
                                </select>
                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>Owned Channel</label>
                                <select class="form-select form-control" placeholder='Owned Channel'
                                        [(ngModel)]="filterParams.owned" (change)="onSelectOwned($event)">
                                    <option value="" [disabled]="true">Select</option>
                                    <option [ngValue]="1">Owned</option>
                                    <option [ngValue]="0">Not Owned</option>
                                </select>
                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>User Scrapping From Msg</label>
                                <select class="form-select form-control" placeholder='Watch User Message'
                                        [(ngModel)]="filterParams.watch_messages_for_scrapping_user" (change)="onSelectOwned($event)">
                                    <option value="" [disabled]="true">Select</option>
                                    <option [ngValue]="1">Enabled</option>
                                    <option [ngValue]="0">Not Enabled</option>
                                </select>
                            </div>
                            <div class="mb-sm-4 col-3 pt-1">
                                <button class="btn btn-primary me-1 mb-3 mt-3" (click)="clearFilter()">Clear</button>
                            </div>
                        </form>

                        <div class="clearfix"></div>
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th></th>
                                <th scope="col" sortable="id" (sort)="onSort($event)">Id</th>
                                <th scope="col" sortable="channel_id" (sort)="onSort($event)">Channel Id</th>
                                <th scope="col" sortable="name" (sort)="onSort($event)">Name</th>
                                <th scope="col" sortable="country_id" (sort)="onSort($event)">Country Name</th>
                                <th scope="col" sortable="added_by_tg_user" (sort)="onSort($event)">Added By</th>
                                <th scope="col" sortable="owned" (sort)="onSort($event)">Owned</th>
                                <th scope="col" sortable="watch_messages_for_scrapping_user" (sort)="onSort($event)">Watch</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of data| paginate: { itemsPerPage: 10, currentPage: currentPage, totalItems: total }">
                                <th><input type="checkbox" name="title_select" onclick="onSelect(item.id)"></th>
                                <th scope="row">{{ item.id }}</th>
                                <th scope="row">{{ item.channel_id }}</th>
                                <th scope="row">{{ item.name }}</th>
                                <th><span *ngIf="item.country != null">{{ item.country.country_name }}</span>
                                <th><span *ngIf="item.user != null">{{ item.user.username }}</span>

                                </th>
                                <td><i *ngIf="item.owned != '0'" class="fa fa-circle {{item.status}} f-12"
                                       style="color: green;">Owned</i>
                                    <i *ngIf="item.owned == '0'" class="fa fa-circle {{item.status}} f-12"
                                       style="color: red;">NotOwn</i>
                                </td>
                                <td><i *ngIf="item.watch_messages_for_scrapping_user != '0'" class="fa fa-circle {{item.status}} f-12"
                                       style="color: green;">Yes</i>
                                    <i *ngIf="item.watch_messages_for_scrapping_user == '0'" class="fa fa-circle {{item.status}} f-12"
                                       style="color: red;">No</i>
                                </td>
                                <th scope="row"><a class="btn btn-primary" (click)="editChannels(item.id)">Edit</a>
                                </th>
                                <!-- <th scope="row"><a class="btn btn-primary" [routerLink]="['/pages/create-page/',item.channel_id]">Edit</a></th> -->
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="d-flex justify-content-center p-2">
                            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-editpages *ngIf="!visible" [id]="editID" (visibleParentPage)="childEmitted($event)"></app-editpages>
<!-- Container-fluid Ends-->
